function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import ChartUtils from "./ChartUtils.js";
import FigureChartModel from "./FigureChartModel.js";
class ChartModelFactory {
  /**
   * Creates a model from the settings provided.
   * Tries to create a Figure in the API with it.
   * @param dh JSAPI instance
   * @param settings The chart builder settings
   * @param settings.isLinked Whether the newly created chart should stay linked with the original table, update when filters are updated
   * @param settings.series The column names to use for creating the series of this chart
   * @param settings.type Chart builder type, from ChartBuilder.types
   * @param settings.xAxis The column name to use for the x-axis
   * @param [settings.hiddenSeries] Array of hidden series names
   * @param table The table to build the model for
   * @returns The ChartModel Promise representing the figure
   * CRA sets tsconfig to type check JS based on jsdoc comments. It isn't able to figure out FigureChartModel extends ChartModel
   * This causes TS issues in 1 or 2 spots. Once this is TS it can be returned to just FigureChartModel
   */
  static makeModelFromSettings(dh, settings, table) {
    return _asyncToGenerator(function* () {
      var figure = yield ChartModelFactory.makeFigureFromSettings(dh, settings, table);
      return new FigureChartModel(dh, figure, settings);
    })();
  }

  /**
   * Creates a model from the settings provided.
   * Tries to create a Figure in the API with it.
   * @param dh DH JSAPI instance
   * @param settings The chart builder settings
   * @param settings.isLinked Whether the newly created chart should stay linked with the original table, update when filters are updated
   * @param settings.series The column names to use for creating the series of this chart
   * @param settings.type Chart builder type, from ChartBuilder.types
   * @param settings.xAxis The column name to use for the x-axis
   * @param [settings.hiddenSeries] Array of hidden series names
   * @param table The table to build the model for
   * @returns The Figure created with the settings provided
   */
  static makeFigureFromSettings(dh, settings, table) {
    return _asyncToGenerator(function* () {
      // Copy the table first and then re-apply the filters from the original table
      // When we add table linking we'll want to listen to the original table and update
      // the copied table with any changes that occur.
      // The table gets owned by the Figure that gets created, which closes the table
      var tableCopy = yield table.copy();
      tableCopy.applyCustomColumns(table.customColumns);
      tableCopy.applyFilter(table.filter);
      tableCopy.applySort(table.sort);
      return dh.plot.Figure.create(new ChartUtils(dh).makeFigureSettings(settings, tableCopy));
    })();
  }

  /**
   * Creates a model from the settings provided.
   * Tries to create a Figure in the API with it.
   * @param dh DH JSAPI instance
   * @param settings The chart builder settings
   * @param settings.isLinked Whether the newly created chart should stay linked with the original table, update when filters are updated
   * @param settings.series The column names to use for creating the series of this chart
   * @param settings.type Chart builder type, from ChartBuilder.types
   * @param settings.xAxis The column name to use for the x-axis
   * @param [settings.hiddenSeries] Array of hidden series names
   * @param figure The figure to build the model for
   * @returns The FigureChartModel representing the figure
   * CRA sets tsconfig to type check JS based on jsdoc comments. It isn't able to figure out FigureChartModel extends ChartModel
   * This causes TS issues in 1 or 2 spots. Once this is TS it can be returned to just FigureChartModel
   */
  static makeModel(dh, settings, figure) {
    return _asyncToGenerator(function* () {
      return new FigureChartModel(dh, figure, settings);
    })();
  }
}
export default ChartModelFactory;
//# sourceMappingURL=ChartModelFactory.js.map